var React = require('react');

function V2 (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"V2"),React.createElement("g",{"style":{"isolation":"isolate"},"key":1},React.createElement("polygon",{"points":"29.85 85.64 48.53 44.33 67.22 3 33.61 1.5 0 0 14.92 42.82 29.85 85.64","fill":"#f47643","style":{"mixBlendMode":"multiply"}}))]);
}

V2.defaultProps = {"viewBox":"0 0 67.21 85.64"};

module.exports = V2;

V2.default = V2;
